import Button from "@/components/ui-kit/button"
import {ReactNode, useState} from "react"
import {classNames} from "@/library/utilities/html"
import {pair} from "@/library/types/pair"
import {AnimatePresence, motion} from "framer-motion"

type MobileToggleProps = {
    toggleButtonText: string
    children?: ReactNode
}

export default function MobileToggle(
    {
        children,
        toggleButtonText
    }: MobileToggleProps
) {
    const [shown, setShown] = useState(false)

    return <div className={classNames(
        "mobile-toggle", "only-lg-and-down",
        pair("toggled", shown)
    )}>
        <div className="toggle-header">
            <Button
                color="primary"
                onClick={() => {
                    setShown(current => !current)
                }}
            ><i className="far fa-filters"/> {toggleButtonText}</Button>
        </div>

        <AnimatePresence mode="sync">
            {shown && <motion.div
                className="toggled-content"
                initial={{
                    y: -50,
                    opacity: 0
                }}
                animate={{
                    y: 0,
                    opacity: 1
                }}
                exit={{
                    y: -50,
                    opacity: 0,
                    height: 0
                }}
            >{children}</motion.div>}
        </AnimatePresence>
    </div>
}
